import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-348a07ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "tw-flex tw-w-full tw-flex-row tw-items-center tw-h-[24px]" }
const _hoisted_4 = ["data-cy"]
const _hoisted_5 = ["id", "data-cy", "data-question-name", "placeholder"]
const _hoisted_6 = {
  key: 0,
  class: "tw-h-[38px] tw-w-[38px] tw-justify-end tw-right-[25px] tw-flex tw-items-center"
}
const _hoisted_7 = {
  key: 1,
  class: "tw-h-[38px] tw-w-[38px] tw-justify-end tw-right-[25px] tw-flex tw-items-center"
}
const _hoisted_8 = {
  key: 2,
  class: "tw-h-[38px] tw-w-[38px] tw-justify-end tw-right-[25px] tw-flex tw-items-center"
}
const _hoisted_9 = ["id", "data-cy"]
const _hoisted_10 = ["id"]
const _hoisted_11 = ["id", "placeholder", "data-cy"]
const _hoisted_12 = ["id", "data-cy", "placeholder"]

import { getComponentUiText } from "@/utils/utilities";
import { computed, onMounted, ref, Ref, watch } from "vue";
import DraggableIcon from "@/components/svgs/draggableIcon.vue";
import BaseInput from "@/components/common/form/baseInput.vue";
import ButtonShowMore from "@/components/common/setting/buttonShowMore.vue";
import { useVuelidate } from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import CustomCheckbox from "../common/customCheckBox.vue";
import CustomBDropDown from "../common/customBDropDown.vue";
import CustomBDropDownItem from "../common/customBDropDownItem.vue";
import { LottieAnimation } from "lottie-web-vue";
import ProgressAnimation from "../../assets/animation/progress_light.json";
import {
  ASSESSMENT_QUESTION_TYPE,
  CHECKLIST_ICON_VALUE_WITH_COLOR,
  CHECKLIST_ICON_VALUE_WITH_COLOR_IMPORTANT,
  VENDOR_TEMPLATE_API_STATUS,
} from "@/utils/constants";
import { IDropDownData } from "@/interfaces/common/IDropDown";
import ArrowVendorQuestion from "../svgs/arrowVendorQuestion.vue";
import store from "@/store";
import CustomDropDownItem from "../common/customDropDownItem.vue";
import { updateChecklistRequestedTemplateItem } from "@/services/vendor";
import cloneDeep from "lodash/cloneDeep";
import { showErrorAPI } from "@/services/apiRoutes";
import { Vendor } from "@/services/apiRoutes/routes";
import SuccessAnimation from "../../assets/animation/success.json";
import ErrorAnimation from "../../assets/animation/error.json";


export default /*#__PURE__*/_defineComponent({
  __name: 'vendorAssessmentQuestion',
  props: {
  item: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  isDefaultExpand: {
    type: Boolean,
    default: false,
  },
  level: {
    type: Number,
    default: 0,
  },
  templateId: {
    type: [String, Number, null],
    required: true,
  },
  isSelected: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: [
  "changeExpand",
  "removeStep",
  "handleUpdateData",
  "update:holdingPutData",
  "handle-select-item",
],
  setup(__props, { expose: __expose, emit: emits }) {

const props = __props;



const holdingPutData = ref({});
const tempName = ref("");

const element = ref({ ...props.item });
const currentValue = ref("");
const isCallAPI = ref(false);
const isSuccess = ref(false);
const isFail = ref(false);

const statusCallAPIPOST = computed(() => {
  const addTemplateItemStatus = store.state.Vendor.addTemplateItemStatus;
  return addTemplateItemStatus.find((x) => x.id === props.item?.id);
});

onMounted(() => {
  if (
    statusCallAPIPOST.value?.loading === VENDOR_TEMPLATE_API_STATUS.isloading
  ) {
    isCallAPI.value = true;
  } else {
    isCallAPI.value = false;
  }
  if (statusCallAPIPOST.value?.loading === VENDOR_TEMPLATE_API_STATUS.suceess) {
    isSuccess.value = true;
    setTimeout(() => {
      isSuccess.value = false;
      store.dispatch("Vendor/setAddTemplateItemStatus", {
        id: props.item.id,
        loading: VENDOR_TEMPLATE_API_STATUS.remove,
      });
    }, 2000);
  }
  if (statusCallAPIPOST.value?.loading === VENDOR_TEMPLATE_API_STATUS.error) {
    isFail.value = true;
    setTimeout(() => {
      store.dispatch("Vendor/setAddTemplateItemStatus", {
        id: props.item.id,
        loading: VENDOR_TEMPLATE_API_STATUS.remove,
      });
      isFail.value = false;
    }, 1500);
  }
});

watch(statusCallAPIPOST, (value) => {
  if (value?.loading === VENDOR_TEMPLATE_API_STATUS.isloading) {
    isCallAPI.value = true;
  } else {
    isCallAPI.value = false;
  }
  if (value?.loading === VENDOR_TEMPLATE_API_STATUS.suceess) {
    isSuccess.value = true;
    setTimeout(() => {
      isSuccess.value = false;
      store.dispatch("Vendor/setAddTemplateItemStatus", {
        id: props.item.id,
        loading: VENDOR_TEMPLATE_API_STATUS.remove,
      });
    }, 2000);
  }
  if (value?.loading === VENDOR_TEMPLATE_API_STATUS.error) {
    isFail.value = true;
    setTimeout(() => {
      store.dispatch("Vendor/setAddTemplateItemStatus", {
        id: props.item.id,
        loading: VENDOR_TEMPLATE_API_STATUS.remove,
      });
      // isFail.value = false;
    }, 1500);
  }
});

const updateHoldingPutData = async (name?) => {
  if (props.item.itemMasterId) {
    try {
      const holdingData = cloneDeep(holdingPutData.value);
      if (!holdingData && !name) {
        return;
      }
      delete holdingData[`olddescription`];
      delete holdingData[`oldresponseType`];
      delete holdingData[`oldimportanceId`];
      if (name) {
        holdingData[`name`] = name;
      }
      // if holdingData is empty object, return
      if (Object.keys(holdingData).length === 0) {
        return;
      }
      isCallAPI.value = true;
      const res = await updateChecklistRequestedTemplateItem({
        templateId: props.templateId,
        params: {
          itemMasterId: element.value.itemMasterId,
          isHeading: false,
          ...holdingData,
        },
      });
      isSuccess.value = true;
      setTimeout(() => {
        isSuccess.value = false;
      }, 2000);
    } catch (error) {
      isFail.value = true;
      setTimeout(() => {
        isFail.value = false;
      }, 1500);
      if (name) {
        element.value["itemMasterName"] = currentValue.value || tempName.value;
      }
      const revertItem = {};
      //emits("handleUpdateData", element.value, props.index);
      if (holdingPutData.value[`olddescription`]) {
        revertItem[`description`] = holdingPutData.value[`olddescription`];
      }
      if (holdingPutData.value[`oldresponseType`]) {
        complianceTypeRef.value = [
          responseTypesDropdownData.value.find(
            (x) => x.id === holdingPutData.value[`oldresponseType`],
          ),
        ];
        revertItem["itemMasterComplianceTypeId"] =
          holdingPutData.value[`oldresponseType`];
      }
      if (holdingPutData.value[`oldimportanceId`]) {
        const score = holdingPutData.value[`oldimportanceId`]
          ? CHECKLIST_ICON_VALUE_WITH_COLOR[
              `${holdingPutData.value[`oldimportanceId`]}`
            ]
          : "tw-text-[#231F20]";
        importanceRef.value = [
          importanceDropdownData.value.find(
            (x) => x.id === holdingPutData.value[`oldimportanceId`],
          ),
        ];
        classImportanceName.value = score;
        element.value.importanceId = holdingPutData.value[`oldimportanceId`];
        handleUpdateData();
      }
      emits("handleUpdateData", revertItem, props.index);
      showErrorAPI(error, Vendor.putChecklistRequestedTemplateItem);
    } finally {
      holdingPutData.value = {};
      isCallAPI.value = false;
    }
  }
};

const handleUpdateAssessmentQuestionName = async (params, propery) => {
  if (props.item.itemMasterId) {
    await v$.value.$validate();
    if (v$.value.$error) {
      if (propery === "itemMasterName") {
        return;
      }
      const param = params;
      param[`old${propery}`] = currentValue.value;
      holdingPutData.value = {
        ...holdingPutData.value,
        ...param,
      };
      return;
    }
    try {
      isCallAPI.value = true;
      await updateChecklistRequestedTemplateItem({
        templateId: props.templateId,
        params: {
          itemMasterId: element.value.itemMasterId,
          isHeading: false,
          ...params,
        },
      });
      isSuccess.value = true;
      setTimeout(() => {
        isSuccess.value = false;
      }, 2000);
    } catch (error) {
      isFail.value = true;
      setTimeout(() => {
        isFail.value = false;
      }, 1500);
      element.value[propery] = currentValue.value;
      if (propery === "responseType") {
        element.value.itemMasterComplianceTypeId = currentValue.value;
        complianceTypeRef.value = [
          responseTypesDropdownData.value.find(
            (x) => x.id === element.value.itemMasterComplianceTypeId,
          ),
        ];
      }
      if (propery === "importanceId") {
        const score = currentValue.value
          ? CHECKLIST_ICON_VALUE_WITH_COLOR[`${currentValue.value}`]
          : "tw-text-[#231F20]";
        importanceRef.value = [
          importanceDropdownData.value.find((x) => x.id === currentValue.value),
        ];
        classImportanceName.value = score;
        element.value.importanceId = currentValue.value;
        handleUpdateData();
      }
      showErrorAPI(error, Vendor.putChecklistRequestedTemplateItem);
    } finally {
      isCallAPI.value = false;
    }
  }
};

const importanceDropdownData: any = computed(() => {
  return store.state.Assessment.importanceAssessment;
});

const responseTypesDropdownData = computed(() => {
  let result: any[] = [];

  const trueFalseText = getComponentUiText(
    "app-component-assessments-assessment-question-type-true-false-1",
  );

  const res = store.state.Assessment.assessmentQuestionTypesClr;

  for (let item of res) {
    // Change name of Type True/False.
    if (item.id === ASSESSMENT_QUESTION_TYPE.TRUE_FALSE) {
      item.name = trueFalseText;
    }

    // Filter out Type Provider | Yes,No.
    if (
      [
        ASSESSMENT_QUESTION_TYPE.PROVIDER,
        ASSESSMENT_QUESTION_TYPE.YES_NO,
      ].indexOf(item.id) < 0
    )
      result.push(item);
  }

  return result;
});

const complianceTypeRef: Ref<IDropDownData[]> = ref([
  responseTypesDropdownData.value.find(
    (x) => x.id === element.value.itemMasterComplianceTypeId,
  ),
]);

const importanceRef: Ref<IDropDownData[]> = ref([
  importanceDropdownData.value.find(
    (x) => x.id === element.value.itemMasterImportanceId,
  ),
]);

const autoTextareaQuestion = ref(null);
const autoTextareaDescription = ref(null);
const isExpand = ref(props.isDefaultExpand === element.value.id);

const autoResizeQuestion = () => {
  if (autoTextareaQuestion.value) {
    autoTextareaQuestion.value.style.height = "auto"; // Reset height
    autoTextareaQuestion.value.style.height =
      autoTextareaQuestion.value.scrollHeight + "px"; // Set height based on content
  }
};

const autoResizeDescription = () => {
  if (autoTextareaDescription.value) {
    autoTextareaDescription.value.style.height = "auto"; // Reset height
    autoTextareaDescription.value.style.height =
      autoTextareaDescription.value.scrollHeight + "px"; // Set height based on content
  }
};

let classImportanceName = ref(
  element.value.importanceId
    ? CHECKLIST_ICON_VALUE_WITH_COLOR[`${element.value.importanceId}`]
    : "tw-text-[#231F20]",
);

const handleScoreSeclected = (event: IDropDownData) => {
  const score = event.id
    ? CHECKLIST_ICON_VALUE_WITH_COLOR[`${event.id}`]
    : "tw-text-[#231F20]";
  importanceRef.value = [event];
  classImportanceName.value = score;
  element.value.importanceId = event.id;
  handleUpdateData();
  if (event.id !== currentValue.value) {
    handleUpdateAssessmentQuestionName(
      {
        importanceId: event.id,
      },
      "importanceId",
    );
  }
};


const handleUpdateExpand = (id) => {
  isExpand.value = !isExpand.value;
  emits("changeExpand", id);
};

const handleUpdateData = () => {
  element.value.isEdit = true;
  emits("handleUpdateData", element.value, props.index);
};

const rules = {
  itemMasterName: {
    required: helpers.withMessage(
      () => getComponentUiText("app-setting-org-detail-required-fields-1"),
      required,
    ),
  },
  questionName: {
    // required: helpers.withMessage(
    //   () => getComponentUiText("app-setting-org-detail-required-fields-1"),
    //   required,
    // ),
  },
  importanceId: {
    required: helpers.withMessage(
      () => getComponentUiText("app-setting-org-detail-required-fields-1"),
      required,
    ),
  },
  responseType: {
    required: helpers.withMessage(
      () => getComponentUiText("app-setting-org-detail-required-fields-1"),
      required,
    ),
  },
};

const v$ = useVuelidate(rules, element.value as any);

const saveChanges = async () => {
  await v$.value.$validate();
  // true is not error
  if (v$.value.$error) {
    isExpand.value = true;
  }
  return !v$.value.$error;
};

__expose({
  saveChanges,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: `vendor-assessment-question-${element.value.id}`,
    key: element.value.id,
    class: "tw-flex tw-w-full tw-flex-col tw-bg-[#FFF] tw-rounded-[6px] tw-overflow-hidden tw-font-[Poppins] assessment-contaier"
  }, [
    _createElementVNode("div", {
      id: `vendor-assessment-question-heading-${element.value.id}`,
      class: _normalizeClass(`tw-flex tw-flex-row tw-items-center tw-justify-between tw-pr-[25px] tw-pl-[0px] tw-py-[20px] tw-bg-[#FCFCFD] tw-h-[64px] tw-rounded-t-[6px] ${
        _unref(v$).itemMasterName?.$errors[0] ? 'is-invalid-input' : ''
      }`)
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          class: "drag-handle tw-cursor-pointer tw-py-[15px] tw-pl-[25px] tw-pr-[10px] tw-flex tw-items-center",
          "data-cy": `drag-handle-${__props.index}`
        }, [
          _createVNode(DraggableIcon, {
            width: 8,
            height: 12
          })
        ], 8, _hoisted_4),
        _createVNode(CustomCheckbox, {
          class: _normalizeClass(`!tw-h-[20px] !tw-mb-0 !tw-pl-0 tw-ml-[0px] tw-mr-[20px]`),
          size: "20px",
          "is-checked": __props.isSelected,
          "onUpdate:isChecked": _cache[0] || (_cache[0] = 
            (value) => {
              emits('handle-select-item', value, __props.index);
            }
          )
        }, null, 8, ["is-checked"]),
        _withDirectives(_createElementVNode("input", {
          id: `input-vendor-question-${__props.index}`,
          "onUpdate:modelValue": [
            _cache[1] || (_cache[1] = ($event: any) => ((element.value.itemMasterName) = $event)),
            _cache[4] || (_cache[4] = 
            (text) => {
              element.value.itemMasterName = text;
              handleUpdateData();
            }
          )
          ],
          "data-cy": `input-question-name-${__props.index}`,
          "data-question-name": `${element.value.itemMasterName}`,
          class: _normalizeClass(`tw-placeholder-[#B7B7B7] tw-ml-[15px] tw-text-[16px] tw-font-medium tw-font-[Poppins] tw-text-[#211F58] tw-w-[inherit] tw-mr-[15px] input-detail-question`),
          placeholder: 
            _unref(getComponentUiText)(
              'app-component-assessments-vendor-question-description-placeholder-1',
            )
          ,
          style: {"border":"unset","background-color":"unset"},
          onFocus: _cache[2] || (_cache[2] = 
            (val) => {
              if (val.target.value !== '') {
                tempName.value = val.target.value;
              }
              currentValue.value = val.target.value;
            }
          ),
          onFocusout: _cache[3] || (_cache[3] = 
            (val) => {
              if (val.target.value === '') {
                handleUpdateAssessmentQuestionName(
                  {
                    name: val.target.value,
                  },
                  'itemMasterName',
                );
                return;
              }
              let putName = false;
              if (
                currentValue.value !== val.target.value &&
                ((val.target.value !== tempName.value && currentValue.value === '') ||
                  currentValue.value !== '')
              ) {
                putName = true;
              }
              updateHoldingPutData(putName ? val.target.value : null);
            }
          )
        }, null, 40, _hoisted_5), [
          [_vModelText, element.value.itemMasterName]
        ]),
        (isCallAPI.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_unref(LottieAnimation), {
                ref: "anim",
                "animation-data": _unref(ProgressAnimation),
                "auto-play": true,
                loop: true
              }, null, 8, ["animation-data"])
            ]))
          : _createCommentVNode("", true),
        (isSuccess.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_unref(LottieAnimation), {
                ref: "anim",
                "animation-data": _unref(SuccessAnimation),
                "auto-play": true,
                loop: true
              }, null, 8, ["animation-data"])
            ]))
          : _createCommentVNode("", true),
        (isFail.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_unref(LottieAnimation), {
                ref: "anim",
                "animation-data": _unref(ErrorAnimation),
                "auto-play": true,
                loop: true
              }, null, 8, ["animation-data"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(ButtonShowMore, {
        "id-popover": `popover-vendor-assessment-question-${__props.index}${
          __props.item.itemMasterId ?? Math.random()
        }`,
        "is-from-notification": true,
        "data-cy-id": `popover-vendor-assessment-question-${__props.index}`,
        "data-question-id": `${__props.item.itemMasterId}`
      }, {
        default: _withCtx(() => [
          _createVNode(CustomDropDownItem, {
            style: 'danger',
            "id-text": 'app-assessment-vendor-delete-question-title-1',
            "style-text": '!tw-self-auto',
            "data-cy": "remove-question-menu",
            "id-item": `popover-vendor-assessment-question-${__props.index}${
            __props.item.itemMasterId ?? Math.random()
          }`,
            onClick: _cache[5] || (_cache[5] = ($event: any) => (emits('removeStep', __props.index)))
          }, null, 8, ["id-item"])
        ]),
        _: 1
      }, 8, ["id-popover", "data-cy-id", "data-question-id"]),
      _createElementVNode("div", {
        id: `vendor-assessment-question-expand-${element.value.id}`,
        "data-cy": `collapse-btn-question-${__props.index}`,
        class: _normalizeClass([
          'tw-ml-[10px]',
          isExpand.value ? 'arrow-up tw-pr-[10px]' : 'arrow-down tw-pl-[10px]',
          'tw-cursor-pointer',
        ]),
        onClick: _cache[6] || (_cache[6] = 
          () => {
            if (isExpand.value) {
              handleUpdateExpand(null);
            } else {
              handleUpdateExpand(element.value.id);
            }
          }
        )
      }, [
        _createVNode(ArrowVendorQuestion)
      ], 10, _hoisted_9)
    ], 10, _hoisted_2),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", {
        id: `vendor-assessment-question-detail-${element.value.id}`,
        class: "detail-question tw-flex tw-px-[25px] tw-py-[35px] tw-gap-[25px] tw-font-[Poppins] tw-bg-white tw-flex-col"
      }, [
        _createVNode(BaseInput, {
          modelValue: element.value.itemMasterName,
          "onUpdate:modelValue": [
            _cache[11] || (_cache[11] = ($event: any) => ((element.value.itemMasterName) = $event)),
            _cache[12] || (_cache[12] = 
            (text) => {
              element.value.itemMasterName = text;
              handleUpdateData();
            }
          )
          ],
          "class-name": `modal-edit-action-step-input !tw-mt-[0px] !tw-mb-[-7px]`,
          "label-class": `tw-mb-[10px] tw-text-[#231F20] tw-flex tw-items-center tw-h-[14px] sm:tw-mt-[18px]`,
          validation: _unref(v$).itemMasterName,
          "valid-message": 
            _unref(getComponentUiText)(
              'app-assess-recommendations-edit-action-modal-action-detail-required-1',
            )
          ,
          label: _unref(getComponentUiText)('app-component-table-header-question-1')
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("textarea", {
              id: `vendor-assessment-question-${__props.index}`,
              ref_key: "autoTextareaQuestion",
              ref: autoTextareaQuestion,
              "onUpdate:modelValue": [
                _cache[7] || (_cache[7] = ($event: any) => ((element.value.itemMasterName) = $event)),
                _cache[10] || (_cache[10] = 
              (text) => {
                element.value.itemMasterName = text;
                handleUpdateData();
              }
            )
              ],
              placeholder: 
              _unref(getComponentUiText)(
                'app-component-assessments-vendor-question-description-placeholder-1',
              )
            ,
              style: `outline-color : #EFF0F1`,
              "data-cy": `question-name-detail-input-${__props.index}`,
              class: _normalizeClass(`tw-max-w-[800px] tw-placeholder-[#B7B7B7] auto-expand tw-min-h-[138px] tw-w-[100%] tw-text-[13px] tw-font-normal tw-leading-none tw-px-5 tw-py-[18px] tw-rounded-md tw-border-solid tw-border-[#EFF0F1] textarea-wrapper ${
              _unref(v$).itemMasterName.$errors[0] ? 'is-invalid-input' : ''
            }`),
              onFocus: _cache[8] || (_cache[8] = 
              (val) => {
                if (val.target.value !== '') {
                  tempName.value = val.target.value;
                }
                currentValue.value = val.target.value;
              }
            ),
              onFocusout: _cache[9] || (_cache[9] = 
              (val) => {
                if (
                  currentValue.value !== val.target.value &&
                  ((currentValue.value !== '' && val.target.value !== tempName.value) ||
                    currentValue.value === '')
                ) {
                  if (val.target.value === '') {
                    handleUpdateAssessmentQuestionName(
                      {
                        name: val.target.value,
                      },
                      'itemMasterName',
                    );
                  } else {
                    updateHoldingPutData(val.target.value);
                  }
                } else {
                  if (val.target.value !== '') {
                    updateHoldingPutData();
                  }
                }
              }
            ),
              onInput: autoResizeQuestion
            }, null, 42, _hoisted_11), [
              [_vModelText, element.value.itemMasterName]
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "validation", "valid-message", "label"]),
        _createVNode(BaseInput, {
          modelValue: element.value.responseType,
          "onUpdate:modelValue": [
            _cache[14] || (_cache[14] = ($event: any) => ((element.value.responseType) = $event)),
            _cache[15] || (_cache[15] = 
            (value) => {
              element.value.responseType = value.id;
              handleUpdateData();
            }
          )
          ],
          "class-name": `!tw-mt-[0px]`,
          "input-class": "!tw-h-[56px]",
          "id-focus": 'input-focus',
          validation: _unref(v$).responseType,
          "valid-message": 
            _unref(getComponentUiText)(
              'app-assess-recommendations-edit-action-modal-action-detail-required-1',
            )
          ,
          "label-class": `tw-flex tw-items-center sm:tw-h-[56px] tw-mb-[10px] sm:tw-mb-0 tw-text-[#231F20]`,
          placeholder: 
            _unref(getComponentUiText)(
              'app-wizards-setup-wizard-more-detail-select-text-1',
            )
          ,
          label: 
            _unref(getComponentUiText)(
              'app-component-assessments-vendor-response-type-title-1',
            )
          
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(`dropdown-container tw-flex-1 dropdown tw-max-w-[800px] ${
              _unref(v$).responseType.$errors[0]
                ? 'is-invalid-input tw-rounded-[6px]'
                : ''
            }`)
            }, [
              _createVNode(CustomBDropDown, {
                id: 'vendor-response-type-' + __props.index,
                data: complianceTypeRef.value,
                "data-cy-id": `question-response-type-${__props.index}`,
                "class-name": 
                'gray-dropdown-container tw-h-[56px] gray-dropdown-container-advance' +
                'white-background'
              ,
                "class-text-placeholder": `tw-border-0 tw-pl-[0px]`,
                placeholder: 
                _unref(getComponentUiText)(
                  'app-wizards-setup-wizard-more-detail-select-text-1',
                )
              ,
                "onUpdate:showDrop": _cache[13] || (_cache[13] = 
                () => {
                  currentValue.value =
                    complianceTypeRef.value && complianceTypeRef.value[0]
                      ? `${complianceTypeRef.value[0].id}`
                      : '';
                }
              )
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(responseTypesDropdownData.value, (itemDropdown, indexDropdown) => {
                    return (_openBlock(), _createBlock(CustomBDropDownItem, {
                      key: indexDropdown,
                      data: itemDropdown,
                      "id-dropdown-item": `vendor-response-type-dropdown-item-${element.value.id}-${indexDropdown}`,
                      "data-cy-id": `question-response-type-item-${__props.index}-${itemDropdown.id}`,
                      "class-name": `normal-dropdown-container tw-text-[#231F20]`,
                      onClick: 
                  () => {
                    complianceTypeRef.value = [itemDropdown];
                    element.value.responseType = itemDropdown.id;
                    handleUpdateData();
                    if (
                      element.value.itemMasterId &&
                      itemDropdown.id !== currentValue.value
                    ) {
                      handleUpdateAssessmentQuestionName(
                        {
                          complianceTypeId: itemDropdown.id,
                        },
                        'responseType',
                      );
                    }
                  }
                
                    }, null, 8, ["data", "id-dropdown-item", "data-cy-id", "onClick"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["id", "data", "data-cy-id", "placeholder"])
            ], 2)
          ]),
          _: 1
        }, 8, ["modelValue", "validation", "valid-message", "placeholder", "label"]),
        _createVNode(BaseInput, {
          modelValue: element.value.importanceId,
          "onUpdate:modelValue": [
            _cache[17] || (_cache[17] = ($event: any) => ((element.value.importanceId) = $event)),
            _cache[18] || (_cache[18] = 
            (text) => {
              element.value.importanceId = text.id;
              handleUpdateData();
            }
          )
          ],
          "class-name": `!tw-mt-[0px]`,
          "input-class": "!tw-h-[56px]",
          "id-focus": 'input-focus',
          validation: _unref(v$).importanceId,
          "valid-message": 
            _unref(getComponentUiText)(
              'app-assess-recommendations-edit-action-modal-action-detail-required-1',
            )
          ,
          "label-class": `tw-flex tw-items-center sm:tw-h-[56px] tw-mb-[10px] sm:tw-mb-0 tw-text-[#231F20]`,
          placeholder: 
            _unref(getComponentUiText)(
              'app-assess-recommendations-edit-action-modal-action-detail-placeholder-1',
            )
          ,
          label: _unref(getComponentUiText)('app-component-table-header-importance-1')
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(`dropdown-container tw-flex-1 dropdown tw-max-w-[800px] ${
              _unref(v$).importanceId.$errors[0]
                ? 'is-invalid-input tw-rounded-[6px]'
                : ''
            }`)
            }, [
              _createVNode(CustomBDropDown, {
                id: `importanceOptionVendor-${element.value.id}-${__props.index}`,
                "data-cy-id": `question-importance-${__props.index}`,
                data: importanceRef.value,
                "class-text-name": `${_unref(classImportanceName)}`,
                "class-name": 
                'vendor-importance-dropdown gray-dropdown-container tw-h-[56px] gray-dropdown-container-advance' +
                'white-background'
              ,
                placeholder: 
                _unref(getComponentUiText)(
                  'app-component-assessments-vendor-question-importance-placeholder-1',
                )
              ,
                "onUpdate:showDrop": _cache[16] || (_cache[16] = 
                () => {
                  currentValue.value =
                    importanceRef.value && importanceRef.value[0]
                      ? `${importanceRef.value[0].id}`
                      : '';
                }
              )
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(importanceDropdownData.value, (itemDropdown, indexDropdown) => {
                    return (_openBlock(), _createBlock(CustomBDropDownItem, {
                      key: indexDropdown,
                      data: itemDropdown,
                      "class-name": `normal-dropdown-container ${
                  itemDropdown.id
                    ? `${
                        _unref(CHECKLIST_ICON_VALUE_WITH_COLOR_IMPORTANT)[
                          `${itemDropdown.id}`
                        ]
                      }`
                    : 'tw-text-[#231F20]'
                }`,
                      "id-dropdown-item": `vendor-importance-item-${element.value.id}-${indexDropdown}`,
                      "data-cy-id": `question-importance-item-${__props.index}-${itemDropdown.id}`,
                      onClick: ($event: any) => (handleScoreSeclected(itemDropdown))
                    }, null, 8, ["data", "class-name", "id-dropdown-item", "data-cy-id", "onClick"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["id", "data-cy-id", "data", "class-text-name", "placeholder"])
            ], 2)
          ]),
          _: 1
        }, 8, ["modelValue", "validation", "valid-message", "placeholder", "label"]),
        _createVNode(BaseInput, {
          modelValue: element.value.description,
          "onUpdate:modelValue": [
            _cache[23] || (_cache[23] = ($event: any) => ((element.value.description) = $event)),
            _cache[24] || (_cache[24] = 
            (text) => {
              element.value.description = text;
              handleUpdateData();
            }
          )
          ],
          "class-name": `modal-edit-action-step-input !tw-mt-[0px] !tw-mb-[-7px]`,
          validation: _unref(v$).description,
          "label-class": `tw-mb-[10px] tw-text-[#231F20] tw-flex tw-items-center tw-h-[14px] sm:tw-mt-[18px]`,
          "valid-message": 
            _unref(getComponentUiText)(
              'app-assess-recommendations-edit-action-modal-action-detail-required-1',
            )
          ,
          label: 
            _unref(getComponentUiText)(
              'app-assess-assessment-modal-create-update-description-1',
            )
          
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("textarea", {
              id: `vendor-assessment-question-description-${__props.index}`,
              ref_key: "autoTextareaDescription",
              ref: autoTextareaDescription,
              "onUpdate:modelValue": [
                _cache[19] || (_cache[19] = ($event: any) => ((element.value.description) = $event)),
                _cache[22] || (_cache[22] = 
              (text) => {
                element.value.description = text;
                handleUpdateData();
              }
            )
              ],
              "data-cy": `question-description-input-${__props.index}`,
              placeholder: 
              _unref(getComponentUiText)(
                'app-component-assessment-create-assessment-modal-field-placeholder-description-1',
              )
            ,
              style: `outline-color : #EFF0F1`,
              class: "tw-max-w-[800px] tw-placeholder-[#B7B7B7] auto-expand tw-min-h-[90px] tw-w-[100%] tw-text-[13px] tw-font-normal tw-leading-none tw-px-5 tw-py-[18px] tw-rounded-md tw-border-solid tw-border-[#EFF0F1] textarea-wrapper",
              onInput: autoResizeDescription,
              onFocus: _cache[20] || (_cache[20] = 
              (val) => {
                currentValue.value = val.target.value;
              }
            ),
              onFocusout: _cache[21] || (_cache[21] = 
              (val) => {
                if (currentValue.value !== val.target.value) {
                  handleUpdateAssessmentQuestionName(
                    {
                      description: val.target.value,
                    },
                    'description',
                  );
                }
              }
            )
            }, null, 40, _hoisted_12), [
              [_vModelText, element.value.description]
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "validation", "valid-message", "label"])
      ], 8, _hoisted_10)
    ], 512), [
      [_vShow, isExpand.value]
    ])
  ], 8, _hoisted_1))
}
}

})